import React from 'react';

export const Image = (props) => {
  return <img src={props.logo} alt={props.logo.alt}/>
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/Image.js